import React from "react";
import { Route, Routes } from "react-router-dom";
import App from "../App";
import Home from "../components/Home/Home";
import Intro from "../components/Intro/Intro";
import IntroClinic from "../components/Intro/IntroClinic";
import IntroMap from "../components/Intro/IntroMap";
import Commu from "../components/Commu/Commu";
import Review from "../components/Commu/Review";
import NonBenefit from "../components/Intro/NonBenefit";
import Grow from "../components/Grow/Grow";
import Disease from "../components/Disease/Disease";
import Info from "../components/Commu/Info";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />}></Route>
      <Route path="/intro" element={<Intro />}></Route>
      <Route path="/clinic" element={<IntroClinic />}></Route>
      <Route path="/map" element={<IntroMap />}></Route>
      <Route path="/nonbenefit" element={<NonBenefit />}></Route>
      <Route path="/commu" element={<Commu />}></Route>
      <Route path="/info" element={<Info />}></Route>
      <Route path="/review" element={<Review />}></Route>
      <Route path="/grow" element={<Grow />}></Route>
      <Route path="/disease" element={<Disease />}></Route>
    </Routes>
  );
};

export default Router;
